import Button from "../Atoms/Button";
import styles from "../../Styles/ActionOptions.module.css";
import { NavLink } from "react-router-dom";

const ActionOptions = ({params}) => {

  return (
    <div className={styles.action_options}>
      <NavLink to={`/${params}/new-note`}>
        <Button>New Note</Button>
      </NavLink>
    </div>
  );
};

export default ActionOptions;
